/* eslint-disable jsdoc/require-jsdoc */
export function versionToNumber(version: string): number {
  return version.split('.').reduce((acc: number, part: string) => {
    return acc * 1e3 + parseInt(part, 10);
  }, 0);
}
